export enum NetworkTier {
    ENHANCED = "ENHANCED",
    STANDARD = "STANDARD",
}

export enum NetworkCode {
    IN_NETWORK = "in_network",
    OUT_OF_NETWORK = "out_of_network",
    UNKNOWN = "unknown",
}

export enum Recipient {
    INDIVIDUAL = "individual",
    FAMILY = "family",
}

export enum NETWORK {
    INDIVIDUAL_IN_NETWORK_ENHANCED = "individual_in_network_ENHANCED",
    INDIVIDUAL_IN_NETWORK_STANDARD = "individual_in_network_STANDARD",
    INDIVIDUAL_IN_NETWORK = "individual_in_network",
    INDIVIDUAL_OUT_OF_NETWORK = "individual_out_of_network",
    INDIVIDUAL_UNKNOWN = "individual_unknown",
    FAMILY_IN_NETWORK_ENHANCED = "family_in_network_ENHANCED",
    FAMILY_IN_NETWORK_STANDARD = "family_in_network_STANDARD",
    FAMILY_IN_NETWORK = "family_in_network",
    FAMILY_OUT_OF_NETWORK = "family_out_of_network",
    FAMILY_UNKNOWN = "family_unknown",
}

export enum Color {
    PRIMARY_BLUE = "#3667E9",
    WHITE = "#FFFFFF",
}
